// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthHeader_container__1FqLO","logoLink":"AuthHeader_logoLink__3dzYm","backArrowBtn":"AuthHeader_backArrowBtn__3Astg","questionMark":"AuthHeader_questionMark__3EMFJ"};